import { api } from '@/lib/api/axios';
import { toApiError } from '@/lib/api/error';
import type { PermissionsResponse } from '@/types/permissions';

/**
 * Single typed wrapper around `GET /api/permissions` (Phase 2 grouped registry).
 * Returned modules are alphabetical; actions inside each module are alphabetical.
 */
export async function getPermissionsRequest(): Promise<PermissionsResponse> {
  try {
    const { data } = await api.get<PermissionsResponse>('/api/permissions');
    return data;
  } catch (e) {
    throw toApiError(e);
  }
}
